// src/pages/About.jsx
import React from "react";

const About = () => {
   return (
      <div>
         {/* Хероблок (фон + большой заголовок) */}
         <section className="relative bg-gray-900 text-white py-32 px-4 sm:px-6 lg:px-8 mb-8">
            <div
               className="absolute inset-0 bg-cover bg-center opacity-50"
               style={{
                  backgroundImage:
                     "url('https://res.cloudinary.com/ddsogzt5j/image/upload/v1742818180/tw0virowcldluvnp6ubm.jpg')",
               }}
            />
            <div className="relative max-w-5xl mx-auto">
               <h1 className="text-4xl sm:text-5xl font-bold mb-4">«Аманкелді арайы» газеті</h1>
               <p className="text-lg text-gray-200">
                  Қостанай облысы Амангелді ауданының қоғамдық-саяси өмірін жариялайтын мерзімді баспасөз
               </p>
            </div>
         </section>

         {/* Основной контент */}
         <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
            <div className="prose lg:prose-xl prose-headings:mb-4">
               <h2>Редакция туралы</h2>
               <p>
                  «Аманкелді арайы» газеті Қостанай облысы Амангелді ауданының қоғамдық-саяси өмірін жариялайтын мерзімді
                  баспасөз. Торғай өңірінде өзіндік өрелі тарихы бар, бағыт-бағдары айқын, аудан жұртшылығы сүйсіне оқитын, тамыры
                  тереңнен бастау алатын беделді басылымдардың бірі.
               </p>
               <p>
                  Сонау <strong>1935 жылдың 15 маусымынан</strong> бері жарық көріп келе жатқан басылым ауданның бас газетіне
                  айналды. Өз тарихында «Социалистік шаруа», «Тың шұғыласы-Целинная заря», «Ақ жол», «Аманкелді арайы» атаулармен
                  шығып тұрды. Ауданымыздың газеті қай кезеңде болсын қасиетті елеміздің, киелі жеріміздің сөзінің төрі болды. Әр
                  дәуірдегі қаламгерлер өзінің халқына айтатын сөзін осы газет арқылы жеткізді.
               </p>
               <p>
                  Мерзімділігі <em>аптасына бір рет</em>. Қостанай облысы Амангелді ауданының барлық елді мекендеріне таралады.
                  Газет <strong>2021 жылдың 23 маусымы</strong> күні Қазақстан Республикасы Ақпарат және қоғамдық даму министрлігі
                  Ақпарат комитетінде қайта тіркеуден өткізіліп, № KZ54VPY00036984 куәлігі берілді.
               </p>
               {/* При желании добавить ещё контента */}
            </div>
         </section>
      </div>
   );
};

export default About;
